export default "__VITE_ASSET__Cs0vv6du__"